<div class="layout-wrapper"
     [ngClass]="containerClass">
    <app-top-bar *ngIf="isLogged"></app-top-bar>

    <app-sidebar *ngIf="isLogged"></app-sidebar>

    <div class="layout-main-container">
    <!--  <div class="layout-main-container" [class.layout-main]="worksel === 'complete' || worksel === 'error'">-->
      <router-outlet></router-outlet>
    </div>

    <!-- Diálogo de confirmación para cierre de sesión -->
    <p-confirmDialog key="sessionClosed" styleClass="session-closed-dialog" />
    <p-confirmDialog />
</div>

